module.exports = __webpack_public_path__ + "static/img/Download_on_the_Play_Store.9c5c5f9.png";